import { Address, IAddress } from '../address';
import { AbstractModel } from '../base';
import {
  IBank,
  IBankData,
  IBankPaymentInstruction,
  IBankPaymentInstructionData,
  IBankPaymentInstructionProperty,
  IBankPaymentInstructionPropertyData
} from './bank.types';

export class Bank extends AbstractModel implements IBank {
  readonly id?: number;
  readonly name: string;
  readonly address: IAddress;
  readonly phone1: string;
  readonly phone2: string = '';

  constructor(data: IBankData) {
    super();

    const requiredFields: (keyof IBankData)[] = ['name', 'address'];

    this.validate(data, requiredFields);

    if (data.id) {
      this.id = data.id;
    }

    this.name = data.name!;
    this.address = new Address(data.address!);
    this.phone1 = data.phone1!;
    if (data.phone2) {
      this.phone2 = data.phone2;
    }
  }

  toString(): string {
    return this.name;
  }
}

export class BankPaymentInstruction extends AbstractModel
  implements IBankPaymentInstruction {
  readonly id?: number;
  readonly identifier: string;
  readonly bank: IBank | number;
  readonly properties: IBankPaymentInstructionProperty[] = [];

  constructor(data: IBankPaymentInstructionData) {
    super();

    const requiredFields: (keyof IBankPaymentInstructionData)[] = [
      'identifier',
      'bank'
    ];

    this.validate(data, requiredFields);

    if (data.id) {
      this.id = data.id;
    }

    this.identifier = data.identifier!;
    this.bank = typeof data.bank == 'number' ? data.bank : new Bank(data.bank!);

    if (data.properties) {
      this.properties = data.properties.map(
        property => new BankPaymentInstructionProperty(property)
      );
    }
  }

  toString(): string {
    return this.identifier + ' - ' + this.bank.toString();
  }
}

export class BankPaymentInstructionProperty extends AbstractModel
  implements IBankPaymentInstructionProperty {
  readonly id?: number;
  readonly property: string;
  readonly value: string;

  constructor(data: IBankPaymentInstructionPropertyData) {
    super();

    const requiredFields: (keyof IBankPaymentInstructionPropertyData)[] = [
      'property',
      'value'
    ];

    this.validate(data, requiredFields);

    if (data.id) {
      this.id = data.id;
    }

    this.property = data.property!;
    this.value = data.value!;
  }
}
